import { useSelector } from "react-redux";

import ExpressiveIcon from "@kikoff/components/src/v1/assets/ExpressiveIcon";
import Card from "@kikoff/components/src/v1/cards/Card";
import { cls } from "@kikoff/utils/src/string";

import {
  EIGHTY_PERCENT_OFF,
  FIRST_MONTH_DISCOUNT_PROMO,
  FREE_BASIC_DISCOUNTED_PREMIUM,
  LAST_MONTH_FREE_PROMO,
  SIX_MONTH_EIGHTY_PERCENT_OFF,
} from "@constant/promos";
import { selectCheckoutPromos } from "@feature/user";
import { l10nResources } from "@util/l10n";

import styles from "./styles.module.scss";

const l10n = l10nResources({
  en: `promo-special-offer = A special promotion was applied, you'll enjoy
promo-first-month-discount-summary = 50% off for the first month
promo-last-month-discount-summary = 1 month free
promo-intro-test-offer-summary = 50% off for the first month
promo-first-free-discounted-premium-summary = $5 off for the first month
promo-eighty-percent-off-summary = 80% off for the first month
promo-six-month-eighty-percent-off-summary = 80% off for 6 months
`,
  es: `promo-special-offer = Se aplicó una promoción especial, la disfrutarás
promo-first-month-discount-summary = 50% de descuento durante el primer mes
promo-last-month-discount-summary = 1 mes gratis
promo-intro-test-offer-summary = 50% de descuento durante el primer mes
promo-first-free-discounted-premium-summary = $5 de descuento durante el primer mes
promo-eighty-percent-off-summary = 80% de descuento durante el primer mes
promo-six-month-eighty-percent-off-summary = 80% de descuento durante los primeros 6 meses
`,
});

function discountSummary(p: string) {
  switch (p) {
    case FREE_BASIC_DISCOUNTED_PREMIUM:
      return "promo-first-free-discounted-premium-summary";
    case FIRST_MONTH_DISCOUNT_PROMO:
      return "promo-first-month-discount-summary";
    case LAST_MONTH_FREE_PROMO:
      return "promo-last-month-discount-summary";
    case EIGHTY_PERCENT_OFF:
      return "promo-eighty-percent-off-summary";
    case SIX_MONTH_EIGHTY_PERCENT_OFF:
      return "promo-six-month-eighty-percent-off-summary";
    default:
      return "";
  }
}

interface StreamlinedPaymentPromoCardProps {
  variant?: "info" | "success";
  className?: string;
  openCaNeedsFirstPayment?: boolean;
}

function StreamlinedPaymentPromoCard({
  variant = "info",
  className,
  openCaNeedsFirstPayment = false,
}: StreamlinedPaymentPromoCardProps) {
  const preview = useSelector((state) => state.shopping.checkoutPreview);
  const promoByTier = useSelector(selectCheckoutPromos());
  if ((!preview && !openCaNeedsFirstPayment) || !promoByTier.basic) {
    return null;
  }

  const discountTitle = discountSummary(promoByTier.basic.name);

  return (
    <Card
      className={cls(
        "row-center py-1.5",
        variant === "success" && "bg:primary-dugout color:primary-strong",
        className
      )}
      dugout={variant === "info"}
    >
      {variant === "info" ? (
        <div
          className={cls("p-1 bg:accent center-child", styles["img-wrapper"])}
        >
          <ExpressiveIcon name="gift-with-bow" />
        </div>
      ) : (
        <div className="text:large+"></div>
      )}
      <div className="column-center ml-2">
        <span className="text:small+">
          {l10n.getString("promo-special-offer")}{" "}
          <b>{l10n.getString(discountTitle)}</b>
        </span>
      </div>
    </Card>
  );
}

export default StreamlinedPaymentPromoCard;
